import { useEffect } from "react";
import Hero from "@/components/ui/Hero";
import EstimateForm from "@/components/forms/EstimateForm";
import Reveal from "@/components/ui/Reveal";
import { TRUST_PILLS, BUSINESS } from "@/lib/constants";

export default function FreeEstimate() {
    useEffect(() => {
        document.title = "Free Pool Cage Repair Estimate Naples FL · A1 Screening";
    }, []);

    return (
        <>
            <Hero
                eyebrow="Free Estimate"
                title="Get a Free Estimate"
                subtitle="Tell us a little about your pool cage or screen and we'll get back to you during business hours."
                primaryCta={{ to: "#estimate-form", label: "Start the form" }}
            />
            <section className="a1-section">
                <div className="a1-container max-w-2xl">
                    <Reveal>
                        <div className="flex flex-wrap gap-2 mb-6 text-sm">
                            {TRUST_PILLS.map((p) => (
                                <span key={p} className="a1-pill">✓ {p}</span>
                            ))}
                        </div>

                        <p className="a1-helper mb-4">
                            Or call <a href={`tel:${BUSINESS.phoneTel}`}>{BUSINESS.phone}</a> · {BUSINESS.hours}
                        </p>
                    </Reveal>

                    <Reveal delay={80}>
                        <div id="estimate-form">
                            <EstimateForm variant="long" source="/free-estimate" />
                        </div>
                    </Reveal>

                    <Reveal delay={160}>
                        <div className="mt-10 a1-card a1-bg-alt">
                            <h3 className="text-lg mb-2">What happens next?</h3>
                            <ol className="space-y-2 text-sm">
                                <li><strong>1.</strong> We review requests during business hours and follow up as soon as the schedule allows.</li>
                                <li><strong>2.</strong> We reach out by your preferred method — phone, text, or email.</li>
                                <li><strong>3.</strong> If we need to come look in person, we schedule that with you. Estimates are free either way.</li>
                            </ol>
                        </div>
                    </Reveal>
                </div>
            </section>
        </>
    );
}
